<template>
  <div>
    <div id="footerCommon"></div>
  </div>
</template>

<script>
  export default {
    name: 'd-footer'
  }
</script>



/** WEBPACK FOOTER **
 ** DFooter.vue?1996d3f2
 **/